import { ReactElement } from 'react'
import { useRouter } from 'next/router'
import { Button } from '@chakra-ui/react'
import { ErrorPageWrapper } from '~/components/ErrorPageWrapper'
import { usePlatformTheme } from '~/context/theme'
import { usePlatformRoutes } from '~/context/partner'
import { useTranslations } from 'next-intl'

function NotFoundErrorPage(): ReactElement {
  const t = useTranslations('pages.not_found')
  const router = useRouter()
  const { themeId } = usePlatformTheme()
  const { createRoutePath } = usePlatformRoutes()

  const redirectToMainPage = () => {
    router.replace(createRoutePath('/'))
  }

  return (
    <ErrorPageWrapper title={t('title')} themeId={themeId}>
      <p>{t('help_message')}</p>
      <p>
        <Button variant="primary" size="md" onClick={redirectToMainPage}>
          {t('back_to_label')}
        </Button>
      </p>
    </ErrorPageWrapper>
  )
}

export default NotFoundErrorPage
